var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record" },
    [
      !_vm.isLoading
        ? _c(
            "csp-record-header",
            {
              attrs: {
                "can-upload-files": _vm.permissions.canUploadFiles,
                "record-id": _vm.recordId,
              },
            },
            [
              _vm.isLoading
                ? _c(
                    "b-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "record-header-left",
                          attrs: { cols: "9" },
                        },
                        [
                          _c("div", [
                            _c("span", { staticClass: "font-weight-bold" }),
                            _vm._v(" "),
                            _c("span"),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "font-weight-bold" }),
                            _vm._v(" "),
                            _c("span"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "record-header-right",
                          attrs: { cols: "3" },
                        },
                        [
                          _c("div", {
                            staticClass: "referenceNumber font-weight-bold",
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "status-bar" }),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLoading
                ? _c(
                    "b-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "record-header-left",
                          attrs: { cols: "9" },
                        },
                        [
                          _c("div", [
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.customer.attributes
                                    .fullNameWithRepresentative
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm.customer.attributes.customerNumber
                                ? _c("span", [
                                    _vm._v(
                                      "\n                            (" +
                                        _vm._s(
                                          _vm.customer.attributes.customerNumber
                                        ) +
                                        ")\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasCustomerDataForDisplay
                                ? _c("span", [
                                    _vm._v(
                                      "\n                            -\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.firm.attributes.name) +
                                  "\n                        "
                              ),
                              _vm.firm.attributes.nameAffix
                                ? _c("span", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.firm.attributes.nameAffix) +
                                        ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                _vm._s(_vm.vehicle.attributes.licensePlate)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("(" + _vm._s(_vm.claimTypeLabel) + ")"),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "record-header-right",
                          attrs: { cols: "3" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "referenceNumber font-weight-bold" },
                            [
                              _vm.furtherReferencNumbersText
                                ? _c("csp-text-with-tooltip", {
                                    attrs: {
                                      text: _vm.referenceNumber,
                                      tooltip: _vm.furtherReferencNumbersText,
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.referenceNumber)),
                                  ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "status-bar" },
                            [
                              _vm.permissions?.canDeleteRecord === true
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "record-delete-button",
                                      attrs: {
                                        size: "sm",
                                        title: "Schadenakte löschen",
                                        variant: "secondary",
                                      },
                                      on: { click: _vm.deleteRecord },
                                    },
                                    [_c("i", { staticClass: "inticon-trash" })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("csp-record-state-overview", {
                                attrs: {
                                  "state-data-items": _vm.stateDataItems,
                                },
                              }),
                              _vm._v(" "),
                              _vm.permissions.canChangeState
                                ? _c("csp-record-state-change", {
                                    attrs: {
                                      "can-create-regress-claim":
                                        _vm.permissions.canCreateRegressClaim,
                                      "can-select-order-scope":
                                        _vm.permissions.canSelectOrderScope,
                                      "record-id": _vm.recordId,
                                      "record-state": _vm.state,
                                    },
                                    on: {
                                      "reload-state-recommended":
                                        _vm.handleReloadStateRecommended,
                                      "state-changed": _vm.reloadWindow,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      }),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center py-5 mb-0" },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        ref: "tabs",
        attrs: { id: "tabs" },
        domProps: { innerHTML: _vm._s(_vm.tabsContent) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }